<div class="email-logs-page">
  <h2 class="email-logs-page__title">Email logs</h2>
  <app-email-logs></app-email-logs>
</div>
